import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../redux/store";
import { Button } from "./button/Button";
import { ModalContext, useModal } from "./Modal";

interface AlertPopupProps {
  header?: string;
  title?: string;
  children?: React.ReactNode;
  closeAction: () => void;
  width?: string;
}

const AlertPopUp = ({
  header,
  title,
  children,
  closeAction,
  width,
}: AlertPopupProps) => {
  const modalContext = useContext(ModalContext);
  const widthStyle = width ? { width } : { width: "400px" };

  const close = modalContext ? modalContext.close : () => {};

  return (
    <div className="app-dialog-container">
      <div
        className="dialog-container dialog-box-min filter-box"
        style={widthStyle}
      >
        <div className="dialog-header"></div>
        <div className="dialog-title">
          <h3>{header ? header : "Alert"}</h3>
        </div>
        <div className="dialog-body">
          {children ? <div>{children}</div> : <div>{title}</div>}
        </div>
        <div className="dialog-footer">
          <div className="apply-cancel">
            <Button
              color="secondary"
              className="btn md"
              variant="solid"
              id="btn-close"
              onClick={closeAction}
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertPopUp;
